import {
  WEBINAR_ERROR_CODES,
  WEBINAR_ERROR_MESSAGES,
  type WebinarErrorCode,
} from '../constants/webinar.constants'

export class WebinarError extends Error {
  readonly code: WebinarErrorCode
  readonly field?: string

  constructor(code: WebinarErrorCode, message?: string, field?: string) {
    super(message ?? WEBINAR_ERROR_MESSAGES[code])
    this.name = 'WebinarError'
    this.code = code
    this.field = field
  }
}

export const isWebinarError = (err: unknown): err is WebinarError =>
  err instanceof WebinarError

export const toWebinarError = (err: unknown): WebinarError => {
  if (isWebinarError(err)) return err
  return new WebinarError(WEBINAR_ERROR_CODES.UNKNOWN)
}

export type WebinarValidationErrors = Record<string, string>

export class WebinarValidationError extends Error {
  readonly errors: WebinarValidationErrors
  constructor(errors: WebinarValidationErrors) {
    super('Webinar validation failed')
    this.name = 'WebinarValidationError'
    this.errors = errors
  }
}

export const isWebinarValidationError = (
  err: unknown,
): err is WebinarValidationError => err instanceof WebinarValidationError
